/**
 * Created by Kieran on 26/09/2017.
 */

import axios from 'axios'
import config from '../../../config/index'

let MedicationsApi = {
  copyDosages(date) {
    return axios.get(config.apiUrl + 'tracking/medication/copy/' + date);
  },
  checkForDosages(date) {
    return axios.get(config.apiUrl + 'tracking/medication/check/' + date + '?requestFrom=web')
  },
  getMedicationsTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/medication/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  deleteMedicationDosage(dosage_id) {
    return axios.delete(config.apiUrl + 'tracking/medication/dosage/' + dosage_id);
  },
  updateMedicationDosage(model) {
    return axios.put(config.apiUrl + 'tracking/medication/dosage/', model)
  },
  deleteMedication(tracking_id) {
    return axios.delete(config.apiUrl + 'tracking/medication/', {
      data: {
        tracking_id: tracking_id
      }
    })
  },
  updateMedication(model) {
    return axios.put(config.apiUrl + 'tracking/medication/', model);
  },
  getMedicationsTrackingCard() {
    return axios.get(config.apiUrl + 'tracking/medication/card/?requestFrom=web');
  },
  postUserMedications(model) {
    return axios.post(config.apiUrl + 'tracking/medications/', model)
  },
  postUserMedication(model) {
    return axios.post(config.apiUrl + 'tracking/medication/', model)
  },
  postMedicationsTracking(model) {
    return axios.post(config.apiUrl + 'tracking/medication/dosage/', model);
  },
  getUserMedications() {
    return axios.get(config.apiUrl + 'tracking/medications/')
  },
  conditionsGet(filter, limit) {
    return axios.get(config.apiUrl + 'list/conditions/' + filter)
  },
  regimeUnitsGet() {
    return axios.get(config.apiUrl + 'list/medications/units/');
  },
  regimeFrequencysGet() {
    return axios.get(config.apiUrl + 'list/medications/frequencys/')
  },
  getTreatments(filter) {
    return axios.get(config.apiUrl + 'list/medications/' + filter)
  }

};

export default MedicationsApi;



// WEBPACK FOOTER //
// ./src/api/Tracking/Medication/index.js